import { Config } from './Config';

export const isEmpty = (obj: Object) => {
	if (!obj) {
		return true;
	}
	return Object.keys(obj).length === 0;
};

export const hasSvgParent = (element: HTMLElement) => {
	while (element.parentElement) {
		if (element.parentElement.tagName.toLowerCase() === 'svg') {
			return true;
		}
		element = element.parentElement;
	}
	return false;
}

export const addUibrainxSelectorPopup = (htmlContent: string) => {
	// check htmlContent has uibrainxSelectorPopup return htmlContent
	if (htmlContent.includes('uibrainxSelectorPopup')) {
		return htmlContent;
	}

	let uibrainxSelectorPopupHTML = `
		<style id="uibrainx-style-editor">
			#uibrainxtag-child::before{content:'uibrainx';opacity:0;position:absolute;visibility:hidden}.uibrainx-selector-rect{position:absolute;z-index:99999999;background:rgba(94,160,255,.5);transition:.1s!important;pointer-events:none}.uibrainx-selector-popup{display:none;position:absolute;z-index:9999999999;padding:15px;width:330px;background-color:#212426;font-size:13px;color:#bfc2c5;border-radius:3px;box-shadow:0 5px 5px -3px rgb(0 0 0 / 20%),0 8px 10px 1px rgb(0 0 0 / 14%),0 3px 14px 2px rgb(0 0 0 / 12%)}.uibrainx-selector-popup__item{margin-bottom:15px}.uibrainx-selector-popup__item:last-child{margin-bottom:0}.uibrainx-selector-popup__item-title{margin-bottom:8px;font-size:14px;font-weight:600}.uibrainx-selector-popup__item-selector{display:flex;flex-wrap:wrap;gap:5px}.uibrainx-selector-popup__item-selector-item{padding:5px;border-radius:3px;background-color:#2b2f30;cursor:pointer;border:1px solid transparent}.uibrainx-selector-popup__item-selector-item:hover{border-color:#7f7f7f}.uibrainx-selector-popup__item-selector-item-toggle{background-image:url(${Config.PUBLIC_URL}/eye.svg);background-repeat:no-repeat;background-position:center;background-size:14px;width:14px;height:12px;background-color:#222426;padding:10px 15px;display:inline-block;vertical-align:middle;margin-right:8px;border-radius:2px}.uibrainx-selector-popup__item-selector-item-toggle--active{background-image:url(${Config.PUBLIC_URL}/eye-slash.svg)}.uibrainx-hide-element{opacity:0!important}.uibrainx-reset-position{transform:translate(0,0)!important;top:0!important;left:0!important;right:auto!important;bottom:auto!important;margin:0!important}
		</style>
		<div class="uibrainx-selector-popup" id="uibrainx-selector-popup"></div>
		<div class="uibrainx-selector-rect" id="uibrainx-selector-rect"></div>
		<script id="uibrainx-functions">
			function uibrainxResetStyle(element) {
			gsap.set(element, { clearProps: 'all' });
			}
			document.querySelectorAll('a').forEach((anchor) => { anchor.addEventListener('click', (e) => { e.preventDefault(); }); });

			function uibrainxShowHideElement(selector) {
			document.querySelectorAll('.uibrainx-hide-element:not(' + selector + ')').forEach((i) => { i.classList.remove('uibrainx-hide-element'); });
			document.querySelectorAll('[data-uibrainx-selector-item-toggle]:not([data-uibrainx-selector-item-toggle="' + selector + '"])').forEach((i) => { i.classList.remove('uibrainx-selector-popup__item-selector-item-toggle--active'); });
			const element = document.querySelector(selector);
			element.classList.toggle("uibrainx-hide-element");
			uibrainxSelectorRect({hide: true});
			document.querySelector('[data-uibrainx-selector-item-toggle="' + selector + '"]')?.classList.toggle("uibrainx-selector-popup__item-selector-item-toggle--active");
			}

			function uibrainxSelectorRect(selectorRect) {
				const uibrainxSelectorRectTag = document.getElementById('uibrainx-selector-rect');
				if (uibrainxSelectorRectTag) {
					if (selectorRect.hide) {
						uibrainxSelectorRectTag.style.cssText = 'width: 0px; height: 0px;';
					} else {
						uibrainxSelectorRectTag.style.cssText = 'top: ' + (selectorRect.top + window.scrollY) + 'px; left: ' +  selectorRect.left + 'px; width: ' + (selectorRect.right - selectorRect.left)  + 'px; height: ' + (selectorRect.bottom - selectorRect.top)  + 'px;';
					}
				}
			}
			
			function uibrainxSelectorPopup(selectorPopup) {
			const uibrainxSelectorPopupTag = document.getElementById('uibrainx-selector-popup');    

			uibrainxSelectorPopupHTML = \`
				<div class="uibrainx-selector-popup__item uibrainx-selector-popup__item--current">
				<div class="uibrainx-selector-popup__item-title" style="color:#fff">Current selector</div>
				<div class="uibrainx-selector-popup__item-selector">\`;
			
			selectorPopup.current.forEach((selector) => {
				uibrainxSelectorPopupHTML += \`
				<div class="uibrainx-selector-popup__item-selector-item" data-uibrainx-selector-item="\${selector}" style="color:#fff"><span class="uibrainx-selector-popup__item-selector-item-toggle" data-uibrainx-selector-item-toggle="\${selector}" onclick="uibrainxShowHideElement(this.getAttribute('data-uibrainx-selector-item-toggle'))"></span>\${selector}</div>\`;
			});

			uibrainxSelectorPopupHTML += \`
				</div>
				</div>\`;

			uibrainxSelectorPopupHTML += \`
				<div class="uibrainx-selector-popup__item uibrainx-selector-popup__item--parent">
				<div class="uibrainx-selector-popup__item-title" style="color:#fff">Parent selector</div>
				<div class="uibrainx-selector-popup__item-selector">\`;
			
			selectorPopup.parent.forEach((selector) => {
				uibrainxSelectorPopupHTML += \`
				<div class="uibrainx-selector-popup__item-selector-item" data-uibrainx-selector-item="\${selector}" style="color:#fff"><span class="uibrainx-selector-popup__item-selector-item-toggle" data-uibrainx-selector-item-toggle="\${selector}" onclick="uibrainxShowHideElement(this.getAttribute('data-uibrainx-selector-item-toggle'))"></span>\${selector}</div>\`;
			});

			uibrainxSelectorPopupHTML += \`
				</div>
				</div>\`;

			if (uibrainxSelectorPopupTag) {
				uibrainxSelectorPopupTag.innerHTML = uibrainxSelectorPopupHTML;
				const uibrainxSelectorPopupTagDisplay = selectorPopup.open ? 'block' : 'none';
				const uibrainxSelectorPopupTagTop = selectorPopup.position.y;
				const uibrainxSelectorPopupTagLeft = window.innerWidth - selectorPopup.position.x < 330 ? selectorPopup.position.x - 330 : selectorPopup.position.x;
				uibrainxSelectorPopupTag.style.cssText = 'display: ' + uibrainxSelectorPopupTagDisplay + '; top: ' + uibrainxSelectorPopupTagTop + 'px; left: ' + uibrainxSelectorPopupTagLeft + 'px; color:#fff;';
				document.querySelectorAll('.uibrainx-hide-element').forEach((i) => { i.classList.remove('uibrainx-hide-element'); });
			}
			}
		</script>
	`;

	return htmlContent.replace('</body>', `
	${uibrainxSelectorPopupHTML}
	</body>`);
}